import { Component } from '@angular/core';
import { FlashMessageService } from '../../services/flash-message.service';
import { FlashMensagem } from '../models/flash-mensagem.model';

/**
 * Exibe lista de mensagens temporárias (sucesso, aviso, erro) vindas do
 * `FlashMessageService`. Suporta **múltiplas mensagens empilhadas**.
 *
 * **Uso:** coloque **um** `<app-flash-message>` na tela (geralmente abaixo
 * do título). Nas classes de página, injete `FlashMessageService` e chame
 * `sucesso`, `aviso`, `erro` (cada chamada **adiciona** uma mensagem) ou
 * `limpar` (descarta todas) — este componente apenas assina `mensagens$`
 * e oferece fechar manual por mensagem.
 */
@Component({
  selector: 'app-flash-message',
  templateUrl: './flash-message.component.html',
  styleUrls: ['./flash-message.component.scss'],
})
export class FlashMessageComponent {
  readonly mensagens$ = this.flash.mensagens$;

  constructor(private flash: FlashMessageService) {}

  fechar(id: number): void {
    this.flash.limparPorId(id);
  }

  trackById(_: number, m: FlashMensagem): number {
    return m.id;
  }
}
